import React, { useState } from "react";
import "../../styles/Landing.css";
import Folder from "../Folders/Folder";
import FolderWindow from "../Folders/FolderWindow";
import LegalFolder from "../Folders/LegalFolder";
import LegalWindow from "../Folders/LegalWindow";
import StreamingWindow from "../Folders/StreamingWindow";
import NewsletterWindow from "../Folders/NewsletterWindow";
import StreamingFolder from "../Folders/StreamingFolder";
import NewsletterFolder from "../Folders/NewsletterFolder";
import PaintFolder from "../Folders/PaintFolder";
import PaintWindow from "../Folders/PaintWindow";
import YoutubeFolder from "../Folders/YoutubeFolder";
import BandcampFolder from "../Folders/BandcampFolder";
import MusicFolder from "../Folders/MusicFolder";
import MusicWindow from "../Folders/MusicWindow";
import SocaFolder from "../Folders/SocaFolder";

const Landing = () => {
    const [openFolders, setOpenFolders] = useState([]);
    const [streamingWindows, setStreamingWindows] = useState([]);
    const [newsletterOpen, setNewsletterOpen] = useState(false);
    const [legalOpen, setLegalOpen] = useState(false);
    const [paintOpen, setPaintOpen] = useState(false);
    const bandCampUrl = "https://akalex.bandcamp.com/album/a-face-in-the-crowd-2024-full-discography";
    const youtubeUrl = "https://www.youtube.com/channel/UCPT5wITq516z9lKrR6viArg";
    const socaUrl = "https://hypeddit.com/akalexmcmazziemcrd/eletebotasoca";


    const handleOpenFolder = (folderName) => {
        if (!openFolders.includes(folderName)) {
            setOpenFolders([...openFolders, folderName]);
        }
    };

    const handleExternalLink = (url) => {
        window.open(url, "_blank");
    };

    const handleCloseFolder = (folderName) => {
        setOpenFolders(openFolders.filter((name) => name !== folderName));
    };

    const handleStreamingClick = (platformName, embedContent) => {
        setStreamingWindows((prev) => [
            ...prev,
            { id: Date.now(), platformName, embedContent },
        ]);
    };

    const handleCloseStreamingWindow = (id) => {
        setStreamingWindows((prev) => prev.filter((window) => window.id !== id));
    };

    const handleOpenNewsletter = () => setNewsletterOpen(true);
    const handleCloseNewsletter = () => setNewsletterOpen(false);

    const handleOpenLegal = () => setLegalOpen(true);
    const handleCloseLegal = () => setLegalOpen(false);

    const handleOpenPaint = () => setPaintOpen(true);
    const handleClosePaint = () => setPaintOpen(false);

    return (
        <div className="container-landing">
            {/* <div className="icon-wrapper" style={{ top: "50px", left: "90px" }}>
                <MusicFolder className="icon-folder" name="MUSIC" onClick={() => handleOpenFolder("MUSIC")} />
            </div> */}
            {/* <div className="icon-wrapper" style={{ top: "150px", left: "190px" }}>
                <Folder className="icon-folder" name="Other stuff" onClick={() => handleOpenFolder("Other stuff")} />
            </div> */}

            <div className="icon-wrapper" style={{ top: "150px", left: "50px" }}>
                <StreamingFolder className="icon-soundcloud" name="SoundCloud" onClick={() =>
                    handleStreamingClick(
                        "SoundCloud",
                        `<iframe width="100%" height="300" scrolling="no" frameborder="no" allow="autoplay" src="https://w.soundcloud.com/player/?url=https%3A//api.soundcloud.com/tracks/2030614008&color=%23ff5500&auto_play=false&hide_related=false&show_comments=true&show_user=true&show_reposts=false&show_teaser=true&visual=true"></iframe>`
                    )
                } />
            </div>

            <div className="icon-wrapper" style={{ top: "350px", left: "270px" }}>
                <NewsletterFolder className="icon-newsletter" name="Newsletter" onClick={handleOpenNewsletter} />
            </div>

            <div className="icon-wrapper" style={{ top: "350px", left: "50px" }}>
                <LegalFolder className="icon-legal" name="Terms & Conditions + Privacy Policy" onClick={handleOpenLegal} />
            </div>

            <div className="icon-wrapper" style={{ top: "450px", left: "250px" }}>
                <PaintFolder className="icon-paint" name="Paint" onClick={handleOpenPaint} />
            </div>
            <div className="icon-wrapper" style={{ top: "480px", left: "50px" }}>
                <YoutubeFolder className="icon-youtube" name="YouTube" onClick={() => handleExternalLink(youtubeUrl)} />
            </div>

            <div className="icon-wrapper" style={{ top: "450px", left: "150px" }}>
                <BandcampFolder className="icon-bandcamp" name="Bandcamp" onClick={() => handleExternalLink(bandCampUrl)} />
            </div>

            <div className="icon-wrapper" style={{ top: "50px", left: "250px" }}>
                <SocaFolder className="icon-soca" name="SOCA - OUT NOW" onClick={() => handleExternalLink(socaUrl)} />
            </div>
            {openFolders.map((folderName) => (
                <div key={folderName} className="folder-window">
                    {folderName === "MUSIC" ? (
                        <MusicWindow
                            folderPath=""
                            onClose={() => handleCloseFolder(folderName)}
                        />
                    ) : (
                        <FolderWindow
                            folderPath=""
                            onClose={() => handleCloseFolder(folderName)}
                        />
                    )}
                </div>
            ))}
            {streamingWindows.map((window) => (
                <div key={window.id} className="folder-window">
                    <StreamingWindow
                        title={window.platformName}
                        embedContent={window.embedContent}
                        onClose={() => handleCloseStreamingWindow(window.id)}
                    />
                </div>
            ))}
            {newsletterOpen && (
                <NewsletterWindow onClose={handleCloseNewsletter} />
            )}
            {legalOpen && (
                <LegalWindow onClose={handleCloseLegal} /> // Affiche LegalWindow
            )}
            {paintOpen && (
                <PaintWindow onClose={handleClosePaint} />
            )}
        </div>
    );
};

export default Landing;